import * as React from 'react';

export function SvgConfluenceNeutral(props: any) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_11636_9715)">
        <path
          d="M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z"
          fill="white"
        />
        <path
          d="M17.8878 14.3803C13.8492 12.4452 12.6693 12.1561 10.9676 12.1561C8.97101 12.1561 7.26933 12.9791 5.74916 15.2923L5.49958 15.6704C5.29538 15.9818 5.25 16.093 5.25 16.2265C5.25 16.3599 5.31807 16.4711 5.56765 16.6268L8.13151 18.2061C8.26765 18.295 8.38109 18.3395 8.49454 18.3395C8.63067 18.3395 8.72143 18.2728 8.85756 18.0726L9.26597 17.4498C9.90126 16.4934 10.4685 16.182 11.1945 16.182C11.8298 16.182 12.5786 16.3599 13.5088 16.8048L16.1861 18.0504C16.4584 18.1838 16.7534 18.1171 16.8895 17.8057L18.1601 15.0476C18.2962 14.7362 18.2055 14.536 17.8878 14.3803ZM6.11219 9.50922C10.1508 11.4443 11.3307 11.7335 13.0324 11.7335C15.029 11.7335 16.7307 10.9105 18.2508 8.59728L18.5004 8.21916C18.7046 7.90776 18.75 7.79655 18.75 7.66309C18.75 7.52964 18.6819 7.41842 18.4324 7.26273L15.8685 5.6835C15.7324 5.59453 15.6189 5.55005 15.5055 5.55005C15.3693 5.55005 15.2786 5.61678 15.1424 5.81696L14.734 6.43975C14.0987 7.39618 13.5315 7.70758 12.8055 7.70758C12.1702 7.70758 11.4214 7.52964 10.4912 7.08479L7.81387 5.8392C7.5416 5.70575 7.24664 5.77247 7.1105 6.08387L5.83992 8.84195C5.70378 9.15334 5.79454 9.35353 6.11219 9.50922Z"
          fill="#1868DB"
        />
      </g>
      <defs>
        <clipPath id="clip0_11636_9715">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
